import {Component, OnInit, SimpleChange, ViewChild} from '@angular/core';
import {SimulationsService} from './simulations.service';
import {Router} from '@angular/router';
import {MatDialog} from "@angular/material";
import {SolutionsEditTableComponent} from "../../dialogs/solutions-edit-table/solutions-edit-table.component";
import {LocalDataSource} from "ng2-smart-table";
import {Ng2SmartTableComponent} from "ng2-smart-table/ng2-smart-table.component";
import {ErrorDialogComponent} from "../../dialogs/error-dialog/error-dialog.component";

@Component({
    selector: 'app-simulation',
    templateUrl: './simulation-list.component.html',
    styleUrls: ['./simulation-list.component.css'],
})
export class SimulationListComponent implements OnInit {

    public tableMetaData: Array<any>;
    public filteredTableMetaData: Array<any>;
    public tableData: Array<any>;

    @ViewChild('table')
    private table: Ng2SmartTableComponent;

    public tableSettings = {
        columns: {},
        attr: {
            class: 'simulation-table'
        },
    };

    public source: LocalDataSource;


    /**
     * @constructor
     * @param {SimulationsService} simulationService
     * @param {Router} router
     */
    constructor(private simulationService: SimulationsService, private router: Router, private dialog: MatDialog) {
    }

    /**
     * Initializing the component
     * Loads the table meta data,
     * Fetches the saved simulations
     */
    ngOnInit() {
        const that = this;

        this.tableMetaData = this.simulationService.tableMetaData;
        this.filterTableMetaData();
        this.simulationService.fetchSavedSimulations().then(
            (result) => {
                that.tableData = result;
                that.source = new LocalDataSource(that.tableData);
            }
        );

        this.table.ngOnChanges({'settings': new SimpleChange(this.table.settings, this.tableSettings, false)});

    }

    /**
     * Method that sets the filteredTableMetaData field by doing a filtering on tableMetaData field.
     * After filtering the filteredTableMetaData will contain only the enabled elements
     */
    public filterTableMetaData() {
        this.filteredTableMetaData = this.tableMetaData.filter((x) => x.enabled);

        const ts = JSON.parse(JSON.stringify(this.tableSettings));

        this.tableSettings['columns'] = {};

        for (const metaData of this.filteredTableMetaData) {
            this.tableSettings['columns'][metaData.key] = {
                title: metaData.title,
                sort: true,
                filter: {
                    type: 'composer',
                    config: {
                        data: this.tableData,
                        searchFields: metaData.key,
                        titleField: metaData.key
                    }
                },
            };
        }

        this.tableSettings['actions'] = {
            columnTitle: 'Actions',
            add: false,
            edit: false,
            delete: false,
            custom: [],
            position: 'left', // left|right
        };

        this.table.settings = this.tableSettings;

        this.table.ngOnChanges({'settings': new SimpleChange(ts, this.tableSettings, false)});

        // this.table.grid.setSettings(this.table.prepareSettings());

    }

    /**
     * Opens a modal dialog in what the user can enable/disable the table fields
     * After the dialog is closed the table columns will be drawn based on what the user selected.
     */
    public openTableEditDialog() {

        const that = this;

        let dialogRef = this.dialog.open(SolutionsEditTableComponent);
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                that.tableMetaData = result;
                that.simulationService.tableMetaData = result;
                that.filterTableMetaData();
            }
        });
    }

    /**
     * This method sends a simulation (previously fetched) to the server and after the server responds navigates to the /saved-simulation route
     * @param simulation
     */
    public loadScenario(simulation) {

        const that = this;

        this.simulationService.fetchSimulation(simulation)
            .then((result) => {
                that.simulationService.loadedSimulation = result;
                that.simulationService.loadedSimulation['data'] = simulation;
                that.simulationService.loadedSimulation['numberOfCycles'] = parseInt(simulation['Num_of_cycles']);
                that.simulationService.loadedSimulation['Currency'] = simulation['Currency'];
                that.simulationService.loadedSimulation['Simulation_Name'] = simulation['Simulation_Name'];
                window.scrollTo(0, 0)

                that.router.navigate(['/saved-simulation'])
            }, (error) => {
                let dialogRef = this.dialog.open(ErrorDialogComponent);
            });
    }
}





// WEBPACK FOOTER //
// /home/sboda/Documents/eIRP/MEA_source_code/src/app/components/simulation-list/simulation-list.component.ts